import MKTypography from "components/MKTypography";

const PolicyText = () => (
  <>
    <MKTypography variant="h2" fontWeight="bold">
      นโยบายความเป็นส่วนตัว
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      นโยบายความเป็นส่วนตัวของบริษัทสำหรับการใช้งานแอปพลิเคชั่นด้านล่าง ซึ่งต่อไปนี้จะเรียกว่า
      “แอปพลิเคชั่น”
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      โปรดอ่านและทำความเข้าใจนโยบายความเป็นส่วนตัวนี้อย่างละเอียด การที่ท่านได้ติดตั้ง
      และ/หรือเข้าใช้งานแอปพลิเคชั่นนี้แล้ว
      ถือว่าท่านตกลงยอมรับข้อกำหนดที่ระบุในนโยบายความเป็นส่วนตัวนี้แล้วทุกประการ
      หากท่านไม่สามารถยอมรับข้อกำหนดนโยบายความเป็นส่วนตัวนี้ได้
      ขอให้ท่านปฏิเสธการใช้งานแอปพลิเคชั่นโดยถอนการติดตั้งแอปพลิเคชั่นจากเครื่องโทรศัพท์เคลื่อนที่/อุปกรณ์ดิจิตอลของท่านทันที
    </MKTypography>
    <br />
    <MKTypography variant="h5" fontWeight="bold">
      1. วัตถุประสงค์ของนโยบายความเป็นส่วนตัว
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      - ข้อมูลที่รวบรวมและเหตุผลที่รวบรวม
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      - การใช้ข้อมูลที่รวบรวม
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      บริษัทจะใช้ข้อมูลที่รวบรวมจากแอปพลิเคชั่นทั้งหมดของบริษัท เพื่อให้บริการ บำรุงรักษา ป้องกัน
      ปรับปรุง พัฒนาบริการใหม่ๆ และปกป้องบริษัทและท่าน ตลอดจนเพื่อนำเสนอเนื้อหาที่ได้รับการปรับแต่ง
      (Customize) ให้เหมาะสมกับการใช้งานของท่านโดยเฉพาะ เช่น แสดงผลการค้นหาที่เกี่ยวข้องกับท่าน
      แสดงโฆษณาประชาสัมพันธ์บริการที่ท่านอาจสนใจและเป็นประโยชน์แก่ท่าน
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      เมื่อท่านติดต่อมายังบริษัท บริษัทอาจเก็บบันทึกข้อมูลการสนทนาระหว่างท่าน กับ Call Center
      ที่บริษัทจัดหามาไว้สำหรับเป็นช่องทางการรับแจ้ง ให้คำปรึกษา
      แนะนำวิธีการแก้ปัญหาที่เกี่ยวข้องกับการใช้งานแอปพลิเคชั่น
      และอาจเก็บบันทึกที่อยู่อีเมลล์ที่ท่านแจ้งไว้เพื่อรับคำแนะนำต่างๆ ทั้งนี้
      เพื่อนำมาปรับปรุงและพัฒนาการให้บริการของบริษัท และบริษัทในเครือ
      และแจ้งให้ท่านทราบผ่านที่อยู่ที่ท่านแจ้งไว้ได้
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      บริษัทอาจใช้ข้อมูลที่รวบรวมได้จากคุกกี้และเทคโนโลยีอื่นๆ เช่น การใช้ Tag เป็นต้น
      ในการปรับปรุงประสบการณ์การใช้งานของท่าน และคุณภาพโดยรวมของแอปพลิเคชั่น
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      ข้อมูลที่แบ่งปัน
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      บริษัทจะไม่นำข้อมูลของท่านไปแบ่งปันหรือเปิดเผยให้กับบริษัท และ/หรือองค์กรอื่น
      และ/หรือบุคคลภายนอก ยกเว้นกรณี ดังต่อไปนี้
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      - เมื่อได้รับความยินยอมจากท่าน บริษัทอาจแบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลของท่านกับบริษัท
      และ/หรือองค์กรอื่น และ/หรือบุคคลภายนอก
      เมื่อได้รับความยิมยอมจากท่านให้แบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลที่ละเอียดอ่อนของท่านก่อน
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      - เพื่อ
      “การใช้ข้อมูลที่รวบรวม”บริษัทอาจแบ่งปันหรือเปิดเผยข้อมูลส่วนบุคคลของท่านกับบริษัทในเครือ
      บริษัทในกลุ่ม ตลอดจนคู่สัญญาที่มีหน้าที่บริหารจัดการแอปพลิเคชั่นตามสัญญากับบริษัทโดยตรง
      หรือบริษัทอื่นที่มีนโยบายเกี่ยวกับข้อมูลส่วนบุคคลที่น่าเชื่อถือ เพื่อให้บริการ บำรุงรักษา
      ป้องกัน ปรับปรุง พัฒนาบริการใหม่ๆ และปกป้องบริษัทและท่าน
      ตลอดจนเพื่อนำเสนอเนื้อหาที่ได้รับการปรับแต่ง (Customize) ให้เหมาะสมกับการใช้งานของท่านโดยเฉพาะ
      เช่น แสดงผลการค้นหาที่เกี่ยวข้องกับท่าน
      แสดงโฆษณาประชาสัมพันธ์บริการที่ท่านอาจสนใจและเป็นประโยชน์แก่ท่าน
      โดยดำเนินการตามคำแนะนำและตามนโยบายส่วนบุคคลของบริษัท
      รวมถึงมาตรการการรักษาข้อมูลที่เป็นความลับและการรักษาความปลอดภัยที่เหมาะสม
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      - สำหรับเหตุผลทางกฎหมาย บริษัทอาจแบ่งปันหรือเปิดเผยข้อมูลของท่านกับบริษัท และ/หรือองค์กรอื่น
      และ/หรือบุคคลภายนอก หากบริษัทเชื่อโดยสุจริตว่าการเข้าถึง การใช้ การเก็บรักษา
      หรือการเปิดเผยข้อมูลนั้น มีเหตุจำป็นอันสมควร (1) เพื่อการปฏิบัติตามกฎหมาย ระเบียบข้อบังคับ
      หลักเกณฑ์ คำสั่งที่เกี่ยวข้องและการร้องขอข้อมูลจากทางราชการ (2)
      เพื่อบังคับใช้ข้อกำหนดในการให้บริการที่เกี่ยวข้อง รวมถึงการตรวจสอบการละเมิดที่อาจเกิดขึ้น (3)
      เพื่อตรวจจับ ป้องกัน หรือตรวจสอบการทุจริต ปัญหาด้านความปลอดภัยหรือด้านเทคนิค (4)
      เพื่อป้องกันอันตรายต่อสิทธิ ทรัพย์สิน หรือความปลอดภัยของบริษัทและ/หรือของท่าน
      หรือบุคคลอื่นตามที่กฎหมายกำหนด
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      บริษัทอาจแบ่งปันข้อมูลที่ไม่สามารถระบุตัวผู้ใช้งานแอปพลิเคชั่น เช่น ผลการค้นหา
      เครื่อข่ายโทรศัพท์เคลื่อนที่ที่ใช้งาน ภาษาที่ใช้ เว็บไซต์ที่เข้าชมบ่อย เป็นต้น
      ต่อสาธารณะหรือให้แก่พันธมิตรทางการค้าของบริษัท เช่น ผู้เผยแพร่โฆษณา ผู้ลงโฆษณา
      หรือเว็บไซต์ที่เชื่อมโยงกัน เช่น บริษัทอาจแบ่งปันข้อมูลที่แสดงแนวโน้มการใช้งานแอปพลิเคชั่น
      สู่สาธารณะ เป็นต้น
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      หากบริษัทมีการเปลี่ยนแปลงโครงสร้างการบริหารงาน เช่น การควบรวมกิจการ การได้มา
      หรือการขายสินทรัพย์ บริษัทจะยังคงรักษาข้อมูลส่วนบุคคลใดๆ ให้เป็นความลับ
      และแจ้งให้ผู้ใช้งานแอปพลิเคชั่นที่ได้รับผลกระทบทราบก่อนการโอนข้อมูลส่วนบุคคล
      หรือให้ข้อมูลส่วนบุคคลนั้นอยู่ภายใต้นโยบายความเป็นส่วนตัวอื่นๆ
    </MKTypography>
    <br />
    <MKTypography variant="h5" fontWeight="bold">
      2. ความปลอดภัยของข้อมูล
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      บริษัทพยายามอย่างยิ่งที่จะปกป้องข้อมูลของท่านจากการเข้าถึง การแก้ไขเปลี่ยนแปลง การเปิดเผย
      หรือการทำลายโดยไม่ได้รับอนุญาต อย่างน้อยดังนี้
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      - บริษัทตรวจสอบการเก็บรวบรวมข้อมูล พื้นที่ในการจัดเก็บข้อมูลและหลักปฏิบัติในการประมวลผล
      รวมถึงมาตรการความปลอดภัยทางกายภาพ เพื่อป้องกันการเข้าถึงข้อมูลโดยไม่ได้รับอนุญาต
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      - บริษัทจำกัดการเข้าถึงข้อมูลส่วนบุคคลไว้เฉพาะกับพนักงาน ลูกจ้าง และตัวแทนของบริษัท
      ที่มีความจำเป็นต้องเข้าถึงข้อมูลนั้นๆ (Need to Know Basis) เพื่อทำการประมวลผลข้อมูล
      โดยที่บุคคลดังกล่าวนั้น
      จะต้องปฏิบัติตามข้อกำหนดเกี่ยวกับการรักษาข้อมูลที่เป็นความลับตามสัญญาอย่างเคร่งครัด
      หากฝ่าฝืนจะมีบทลงโทษขั้นรุนแรง
    </MKTypography>
    <br />
    <MKTypography variant="h5" fontWeight="bold">
      3. ข้อจำกัดการใช้นโยบายความเป็นส่วนตัว
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      นโยบายความเป็นส่วนตัวฉบับนี้ มีผลใช้บังคับกับแอปพลิเคชั่นนี้เท่านั้น
      ไม่รวมถึงแอปพลิเคชั่นและ/หรือบริการที่มีนโยบายความเป็นส่วนตัว แยกต่างหาก
      และ/หรือที่ไม่ได้กำหนดโดยชัดแจ้งให้ใช้ร่วมกันกับนโยบายความเป็นส่วนตัวนี้
      ตลอดจนไม่มีผลใช้บังคับกับแอปพลิเคชั่นและบริการ หรือเว็บไซต์อื่นๆ ที่เชื่อมต่อ (link)
      กับแอปพลิเคชั่นนี้ รวมถึงไม่ครอบคลุมหลักปฏิบัติด้านข้อมูลส่วนบุคคลของบริษัทอื่นๆ
      หรือองค์กรอื่นๆ ที่โฆษณาแอปพลิเคชั่นของบริษัท ซึ่งอาจใช้คุกกี้ พิกเซลแท็ก และเทคโนโลยีอื่นๆ
      ในการนำเสนอและแสดงโฆษณาที่เกี่ยวข้อง
    </MKTypography>
    <br />
    <MKTypography variant="h5" fontWeight="bold">
      4. การปฏิบัติตามกฎหมายและการให้ความร่วมมือกับหน่วยงานกำกับดูแล
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      บริษัทดำเนินการตรวจสอบและทบทวนการปฏิบัติตามนโยบายความเป็นส่วนตัว
      และการปฏิบัติตามกฎหมายที่เกี่ยวข้อง ภายในองค์กรอย่างสม่ำเสมอ (Self-Regulator)
      หากบริษัทได้รับหนังสือร้องเรียนเกี่ยวกับการใช้ข้อมูลส่วนบุคคล บริษัทจะดำเนินการติดตามผล
      ตลอดจนให้ความร่วมมือกับหน่วยงานของรัฐที่มีอำนาจกำกับดูแลการให้บริการแอปพลิเคชั่น
      และหน่วยงานคุ้มครองผู้บริโภคต่างๆ
    </MKTypography>
    <br />
    <MKTypography variant="h5" fontWeight="bold">
      5. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      บริษัทขอสงวนสิทธิ์ในการแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้ได้ตลอดเวลา
      โดยไม่ต้องได้รับความยินยอมจากท่านล่วงหน้า
      เว้นแต่เป็นการแก้ไขเปลี่ยนแปลงที่เป็นการริดรอนสิทธิของท่านตามนโยบายความเป็นส่วนตัวนี้
      บริษัทจะกระทำมิได้หากไม่ได้รับความยินยอมจากท่านก่อน
    </MKTypography>
    <br />
    <MKTypography variant="h5" fontWeight="bold">
      6. การเข้าถึงและอัปเดตข้อมูลส่วนบุคคล
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      บริษัทมุ่งหวังเป็นอย่างยิ่งว่า ในการใช้แอปพลิเคชั่น ท่านสามารถเข้าถึงข้อมูลส่วนบุคคลของท่านได้
      หากข้อมูลดังกล่าวมีความบกพร่องหรือไม่ถูกต้อง บริษัทจะพยายามจัดหาวิธีการ
      และ/หรือช่องทางให้ท่านสามารถอัปเดตและ/หรือลบข้อมูลส่วนบุคคลของท่านได้อย่างเหมาะสม เว้นแต่
      ในกรณีมีความจำเป็นที่บริษัทจะต้องจัดเก็บข้อมูลส่วนบุคคลของท่านไว้ เพื่อประโยชน์ทางธุรกิจ
      และ/หรือเพื่อการปฏิบัติตามกฎหมายที่ใช้บังคับ เมื่อท่านดำเนินการอัปเดตข้อมูลส่วนบุคคลของท่าน
      บริษัทอาจร้องขอให้ท่านยืนยันตัวตนก่อนที่บริษัทจะดำเนินการตามคำขอของท่านได้ ทั้งนี้
      บริษัทขอสงวนสิทธิ์ปฏิเสธการทำคำขออัปเดตและการเข้าถึงข้อมูลส่วนบุคคลของท่าน ในกรณีดังต่อไปนี้
      (1) การทำคำขอที่ซับซ้อนและมีจำนวนมากเกินกว่าปกติ (2)
      การดำเนินการตามคำขออาจทำให้บริษัทต้องจัดหา และ/หรือพัฒนาเทคโนโลยีจากที่บริษัทมีอยู่เกินสมควร
      (3) การดำเนินการตามคำขออาจกระทบข้อมูลส่วนบุคคลของผู้ใช้งานแอปพลิเคชั่นอื่นๆ หรือ (4)
      การดำเนินการตามคำขอไม่สามารถปฏิบัติได้จริง เช่น
      คำขอเกี่ยวกับการเรียกดูข้อมูลส่วนบุคคลที่อยู่ในระบบสำรองข้อมูล
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      บริษัทมุ่งหวังที่จะดำเนินการให้บริการแอปพลิเคชั่นของบริษัทเป็นไปอย่างปลอดภัย
      และสามารถป้องกันการทำลายข้อมูลจากอุบัติเหตุหรือการมุ่งร้ายอื่นๆ ด้วยเหตุนี้
      ภายหลังจากที่ท่านลบข้อมูลออกจากแอปพลิเคชั่นของบริษัทแล้ว
      บริษัทอาจยังไม่ดำเนินการลบสำเนาข้อมูลส่วนบุคคลที่มีอยู่ออกจากเซิร์ฟเวอร์ที่ใช้งานอยู่
      หรือนำข้อมูลออกจากระบบสำรองของบริษัทในทันที
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      ข้อมูลที่รวบรวมและเหตุผลที่รวบรวม
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      บริษัทเก็บรวบรวมข้อมูล เพื่อนำมาใช้ในการพัฒนาและปรับปรุงการให้บริการที่ดีขึ้นแก่ท่าน
      โดยเริ่มตั้งแต่ข้อมูลพื้นฐาน อย่างเช่น ตำแหน่งที่อยู่ปัจจุบัน ชื่อจุดเริ่มต้นเดินทาง
      ชื่อจุดหมาย ตลอดจนข้อมูลที่มีความซับซ้อน เช่น ระยะเวลาการรอรถ เวลาในการเดินทาง
      ประวัติของจุดหมาย เป็นต้น ด้วยวิธีดังต่อไปนี้
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      ข้อมูลที่ท่านให้บริษัท
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      ให้ท่านแจ้งจุดเริ่มต้นเดินทาง และจุดหมายปลายทาง รวมทั้งแจ้งเริ่มเดินทางด้วยรถสาธารณคันที่มาถึง
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      ข้อมูลที่บริษัทได้รับจากการใช้งานแอปพลิชั่นของท่านข้อมูลที่ท่านให้บริษัท
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      บริษัทรวบรวมข้อมูลจากการใช้งานแอปพลิเคชั่นของท่าน เช่น ท่านแจ้งจุดเริ่มต้นเดินทาง
      และจุดหมายปลายทาง รวมทั้งแจ้งเริ่มเดินทางด้วยรถสาธารณคันที่มาถึง เป็นต้น
      ซึ่งประกอบด้วยข้อมูลอย่างน้อยดังนี้
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      (1) ข้อมูลเครื่องโทรศัพท์เคลื่อนที่/อุปกรณ์ดิจิตอล :
    </MKTypography>
    <MKTypography variant="body1" color="text">
      บริษัทจะรวบรวมข้อมูลเฉพาะของอุปกรณ์ เช่น รุ่นฮาร์ดแวร์ ระบบปฏิบัติการและรุ่นของระบบปฏิบัติการ
      ข้อมูลเครือข่ายโทรศัพท์เคลื่อนที่ หมายเลขโทรศัพท์
      ตลอดจนตัวระบุอุปกรณ์ที่ทำให้บริษัททราบว่าท่านเข้าใช้งานแอปพลิเคชั่นจากเครื่องใด
      เพื่อนำมาปรับแต่งการให้บริการและวิเคราะห์ปัญหาที่เหมาะสมกับอุปกรณ์นั้นๆ
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      (2) ข้อมูลที่ถูกบันทึก :
    </MKTypography>
    <MKTypography variant="body1" color="text">
      เมื่อท่านเรียกดูข้อมูลและ/หรือเนื้อหาจากแอปพลิเคชั่นนี้
      บริษัทจะบันทึกการเรียกดูข้อมูลและ/หรือเนื้อหาดังกล่าวไว้ในแหล่งรวบรวมดังต่อไปนี้
      ในเซิร์ฟเวอร์ของบริษัทเอง และ/หรือของบริษัทในเครือ
      และ/หรือของคู่สัญญาที่เชื่อถือได้ของบริษัทที่ทำหน้าที่บริหารจัดการข้อมูลในแอปพลิเคชั่นตามสัญญา
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      - เพื่อช่วยในการอำนวยความสะดวกในการเดินทางครั้งต่อไป
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      (3) ข้อมูลสถานะของเครื่องโทรศัพท์เคลื่อนที่ (Phone State) :
    </MKTypography>
    <MKTypography variant="body1" color="text">
      บริษัทอาจเข้าถึงและประมวลผลข้อมูลเกี่ยวกับสถานะการทำงานของเครื่องโทรศัพท์เคลื่อนที่ของท่านว่าเปิดเครื่อง
      หรือปิดเครื่องอยู่ และ/หรือข้อมูลเกี่ยวกับการเชื่อมต่อเครือข่าย เช่น
      เลือกเชื่อมต่อผ่านเครือข่ายโทรศัพท์เคลื่อนที่ หรือระบบ Wi-Fi เป็นต้น วัตถุประสงค์ดังนี้
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      - เพื่อการจัดทำหน้าจอแสดงผลก่อนการเข้าถึงหน้าหลักของแอปพลิเคชั่น (Splash Screen)
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      - เพื่อปรับแต่งการให้บริการแอปพลิเคชั่นที่เหมาะสมกับสถานะการใช้งานเครื่องแต่ละรูปแบบ เช่น
      การสลับรูปแบบการใช้งานและปรับระดับเสียงในการนำทาง เป็นต้น
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      (4) คุกกี้และเทคโนโลยีที่คล้ายกัน (Cookies and Similar Technologies) :
    </MKTypography>
    <MKTypography variant="body1" color="text">
      บริษัท กับบริษัทในเครือ และ/หรือพันธมิตรทางธุรกิจของบริษัท อาจใช้เทคโนโลยีต่างๆ
      ในการรวบรวมและจัดเก็บข้อมูลเมื่อท่านเยี่ยมชมเว็บไซต์และ/หรือบริการของบริษัท
      โดยการใช้คุกกี้และเทคโนโลยีที่คล้ายกัน เพื่อระบุบราวเซอร์หรืออุปกรณ์
      และ/หรือเพื่อรวบรวมและจัดเก็บข้อมูลเมื่อท่านมีการโต้ตอบกับบริการที่บริษัทให้กับบริษัทในเครือ
      และ/หรือพันธมิตรทางธุรกิจของบริษัท เช่น บริการโฆษณา เป็นต้น
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      (5) ข้อมูลหมายเลขเฉพาะของแอปพลิเคชั่น (Unique Application Number) :
    </MKTypography>
    <MKTypography variant="body1" color="text">
      แอปพลิเคชั่นนี้มีหมายเลขเฉพาะของแอปพลิเคชั่น สำหรับการส่งข้อมูลมายังบริษัท
      เมื่อผู้ใช้บริการทำการติดตั้ง หรือถอนการติดตั้งแอปพลิเคชั่นนั้นๆ
      หรือเมื่อแอปพลิเคชั่นนั้นติดต่อกับระบบเซิร์ฟเวอร์การให้บริการของบริษัทเป็นคราวๆไป
      วัตถุประสงค์ดังนี้
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      - เพื่อการอัปเดตข้อมูลแอปพลิเคชั่นโดยอัตโนมัติ
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      (6) ข้อมูลพื้นที่การจัดเก็บข้อมูลในตัวเครื่อง (Storage) :
    </MKTypography>
    <MKTypography variant="body1" color="text">
      บริษัทอาจรวบรวมและจัดเก็บข้อมูล พื้นที่การจัดเก็บข้อมูลในตัวเครื่อง
      รวมถึงข้อมูลส่วนบุคคลที่อยู่ในอุปกรณ์ของท่าน โดยใช้วิธีการต่างๆ เช่น
      พื้นที่จัดเก็บข้อมูลเว็บบราวเซอร์ และแคชของข้อมูลแอปพลิเคชั่น วัตถุประสงค์ดังนี้
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      - เพื่ออนุญาตให้แอปพลิเคชั่นสามารถอ่าน เพื่อแสดงข้อมูลของผู้ใช้ตามการเข้าใช้งานบนแอปพลิเคชั่น
    </MKTypography>
    <br />
    <MKTypography variant="h5" color="text">
      (7) ข้อมูลตำแหน่ง (Location) :
    </MKTypography>
    <MKTypography variant="body1" color="text">
      บริษัทอาจเข้าถึง รวบรวมและประมวลผลข้อมูลเกี่ยวกับตำแหน่งที่แท้จริงของท่าน
      เมื่อคุณเปิดฟังก์ชั่นการระบุตำแหน่งสถานที่ปัจจุบันของคุณโดยผ่านอุปกรณ์มือถือที่มี GPS
      โดยมีวัตถุประสงค์ดังนี้
    </MKTypography>
    <br />
    <MKTypography variant="body1" color="text">
      - เพื่อใช้ระบุตำแหน่งปัจจุบันของผู้ใช้บนแผนที่
    </MKTypography>
  </>
);
export default PolicyText;
